const ar = {
  nav: {
    home: "الرئيسية",
    about: "من نحن",
    destinations: "الوجهات",
    tours: "الجولات والباقات",
    gallery: "المعرض",
    testimonials: "آراء العملاء",
    blog: "المدونة",
    contact: "اتصل بنا",
    experiences: "التجارب",
    vip: "VIP أعمال",
    vipFull: "سفر VIP للأعمال",
    worldcup: "كأس العالم 2030",
    menu: "القائمة",
    chatWhatsApp: "تحدث عبر واتساب",
    jewishHeritage: "سياحة كوشر"
  },
  hero: {
    welcome: "مرحباً بك في المغرب.",
    welcomeHome: "مرحباً بك في بيتك.",
    subtitle: "جولات خاصة فاخرة، تجارب أصيلة،",
    subtitleLine2: "وخدمة شخصية كاملة في جميع أنحاء المغرب —",
    subtitleGold: "يديرها المدير التنفيذي شخصياً.",
    whatsappBtn: "تحدث مع إيلان (المدير التنفيذي) الآن عبر واتساب",
    badgeFast: "استجابة سريعة",
    badgePersonal: "خدمة شخصية",
    badge247: "متاح 24/7",
    limitedAvail: "توفر محدود",
    personalizedOnly: "رحلات مخصصة فقط"
  },
  strip: {
    privateTours: "جولات خاصة",
    localExperts: "خبراء محليون",
    bestHotels: "أفضل الفنادق",
    luxuryTransport: "نقل فاخر",
    satisfaction: "رضا 100%"
  },
  cta: {
    whatsapp: "تحدث مع إيلان (المدير التنفيذي) الآن عبر واتساب",
    whatsappFloating: "تحدث عبر واتساب",
    whatsappInquiry: "مرحباً، أنا مهتم بتجربة سفر فاخرة في المغرب."
  },
  home: {
    vipBannerTitle: "تجارب سفر VIP في المغرب",
    vipBannerText: "وصول حصري، سائقون خاصون، وإقامات فاخرة مصممة للمسافرين المميزين.",
    vipBannerBtn: "اكتشف خدمات VIP",
    wcBadge: "🇲🇦 كأس العالم المغرب 2030",
    wcTitle: "المغرب 2030",
    wcText: "باقات حصرية لكأس العالم تجمع بين كرة القدم والثقافة المغربية والضيافة الفاخرة.",
    wcBtn: "عرض الباقات",
    galleryTitle: "المعرض",
    gallerySubtitle: "لمحة عن رحلتك المغربية المستقبلية",
    exploreDestination: "استكشف الوجهة",
    featuredToursTitle: "الجولات والباقات المميزة",
    featuredToursSubtitle: "تجارب منتقاة بعناية للمغامرة المغربية المثالية",
    viewAllTours: "عرض جميع الجولات",
    culinaryTitle: "طعامنا - الأفضل في العالم",
    culinarySubtitle: "جرب التميز الطهوي المغربي 🍲",
    culinaryBtn: "اكتشف تجارب الطهي",
    culinaryIntro: "في Morocco Loves You، تناول الطعام ليس مجرد أكل. إنها رحلة في قلب الثقافة المغربية. نحن نقدم تجارب طهي أصلية ومختارة بعناية — من الوجبات المنزلية التقليدية إلى المطبخ المغربي الراقي، وكلها معدة بحب وبأحدث المكونات المحلية.",
    videoTitle: "توصيات",
    unityQuote: "موروكو لوفز يو ترحب بجميع الثقافات وجميع المعتقدات وجميع الشعوب.",
    unityAlt: "موروكو لوفز يو شعار الوحدة",
    testimonialsTitle: "ماذا يقول ضيوفنا VIP",
    testimonialsSubtitle: "تقييمات حقيقية من مسافرين دوليين",
    readMoreReviews: "اقرأ المزيد من التقييمات",
    viewAllTransport: "عرض جميع وسائل النقل",
    transportTitle: "خدمة النقل والسائقين VIP لدينا",
    transportSubtitle: "الفخامة والراحة والأمان في جميع أنحاء المغرب 🌍",
    transportIntro: "في Morocco Loves You، النقل ليس مجرد انتقال من مكان إلى آخر. إنه جزء من التجربة. نحن نوفر مركبات حديثة، نظيفة، مريحة، ومكيفة بالكامل في جميع أنحاء المغرب — مع سائقين محترفين، وضيافة دافئة، وخدمة VIP من اللحظة الأولى."
  },
  tours: {
    pageTitle: "الجولات والباقات",
    pageSubtitle: "اختر من باقات السفر المنتقاة بعناية",
    sectionTitle: "باقاتنا السياحية",
    sectionIntro: "من مغامرات الصحراء إلى الإجازات الساحلية، لدينا الباقة المثالية لكل مسافر",
    howToBook: "كيفية الحجز",
    step1Title: "اختر جولة",
    step1Text: "تصفح باقاتنا واختر الأنسب لك",
    step2Title: "انقر على الحجز",
    step2Text: "انقر على زر \"احجز الآن\" في الجولة المختارة",
    step3Title: "أكمل البيانات",
    step3Text: "قدم تواريخ سفرك ومعلوماتك الشخصية",
    step4Title: "التأكيد",
    step4Text: "استلم التأكيد وتفاصيل خط السير عبر البريد الإلكتروني",
    customTitle: "تحتاج باقة مخصصة؟",
    customText: "تواصل معنا لإنشاء تجربة مغربية مخصصة",
    customBtn: "تواصل معنا",
    days: "أيام",
    highlights: "أبرز المعالم:",
    bookNow: "احجز الآن",
    highlightsLabel: "أبرز المعالم:",
    viewFullDetails: "عرض التفاصيل الكاملة",
    viewDetails: "عرض التفاصيل",
    premiumPackage: "باقة ممتازة",
    arrival: "الوصول:",
    route: "المسار:",
    flights: "الرحلات الجوية:",
    transportation: "النقل:",
    hotels: "الفنادق:",
    foodDining: "الطعام والوجبات:",
    whatsIncluded: "ما تشمله الباقة:",
    attractionsExperiences: "المعالم السياحية والتجارب:",
    specialSaharaExperience: "تجربة الصحراء الخاصة:",
    suitableFor: "مناسب لـ:",
    importantNotes: "ملاحظات هامة:",
    priceInformation: "معلومات الأسعار:",
    priceWarningText: "قد تتغير الأسعار اعتماداً على أسعار الطيران، وأسعار الصرف، والعطلات، والمواسم، وتوفر الفنادق.",
    safetyComfort: "الأمان والراحة:",
    safetyText: "نحن نعمل بالتنسيق مع السلطات المغربية والأجهزة الأمنية لضمان سلامة وراحة ضيوفنا.",
    safetyTextBrief: "بالتنسيق مع السلطات المغربية لسلامتك.",
    givesMore: "موروكو لوفز يو تمنحك المزيد:",
    givesMoreText: "المزيد من الحب والرعاية والاحترافية والبهجة والسلامة. جولات سهلة ومريحة بضيافة إنسانية حقيقية.",
    givesMoreBrief: "موروكو لوفز يو:",
    givesMoreTextBrief: "المزيد من الحب والرعاية والاحترافية.",
    bookThisPackage: "احجز هذه الباقة",
    backToPackages: "العودة للباقات",
    premiumMoroccoPackages: "باقات المغرب الممتازة",
    premiumMoroccoPackagesDesc: "تجارب حصرية منتقاة بعناية لضيوفنا المميزين.",
    suitable: {
      couples: "الأزواج",
      families: "العائلات",
      groups: "المجموعات",
      solo: "المسافرون المنفردون",
      seniors: "كبار السن",
      companies: "الشركات",
      agencies: "وكالات السفر",
      operators: "منظمو الرحلات"
    },
    pkg1: {
      title: "هروب عطلة نهاية الأسبوع الفاخرة في فاس",
      duration: "3 ليالٍ / 4 أيام (الخميس ← الأحد)",
      price: "790 يورو",
      hl1: "رحلات طيران مباشرة ذهاباً وإياباً مشمولة (لندن/أوروبا)",
      hl2: "فنادق فاخرة 4-5 نجوم",
      hl3: "حمام مغربي تقليدي",
      hl4: "ورش عمل الطهي والفنون",
      hl5: "عروض مغربية حية",
      hl1_brief: "رحلات طيران مباشرة ذهاباً وإياباً مشمولة",
      subtitle: "باقة شاملة كلياً - من الألف إلى الياء",
      flight1: "رحلات طيران مباشرة ذهاباً وإياباً",
      flight2: "حقيبة مسجلة بوزن 20 كجم",
      flight3: "حقيبة مقصورة حتى 8 كجم",
      inc1: "الاستقبال في المطار والتوصيل للعودة",
      inc2: "فنادق 4-5 نجوم (نصف إقامة)",
      inc3: "مطبخ مغربي طازج وأصيل",
      inc4: "تجربة الشاي والحلويات التقليدية",
      inc5: "مرشد سياحي محترف وسائق خاص",
      inc6: "وسائل نقل حديثة مكيفة",
      inc7: "عروض حية خاصة (مغنون وراقصون)",
      inc7_brief: "عروض حية خاصة",
      inc8: "جولات في الأسواق التقليدية (التوابل، الفوانيس، السجاد)",
      inc8_brief: "جولات في الأسواق التقليدية",
      inc9: "ورش عمل الطهي والفنون (يتطلب الحجز المسبق)",
      inc9_brief: "ورش عمل الطهي والفنون",
      inc10: "زيارات الينابيع الطبيعية والمطلات",
      inc11: "رحلات يومية إلى شفشاون وإفران",
      inc12: "زيارات مع عائلات مغربية محلية",
      inc13: "تجارب مفاجئة أثناء الجولة",
      suit1: "الأزواج",
      suit2: "العائلات",
      suit3: "المجموعات",
      suit4: "المسافرون المنفردون",
      suit5: "كبار السن",
      suit6: "الشركات",
      suit7: "وكالات السفر",
      suit8: "منظمو الرحلات"
    },
    pkg2: {
      title: "جولة اكتشاف المغرب الفاخرة",
      duration: "6 ليالٍ / 7 أيام (الإثنين ← الأحد)",
      price: "1490 يورو",
      hl1: "مسار فاس وشمال المغرب",
      hl2: "زيارات شفشاون وطنجة",
      hl3: "رحلات طيران مباشرة وسائق خاص",
      hl4: "مواقع ممتازة وخدمة عالية المستوى",
      hl5: "ضيافة مغربية أصيلة",
      subtitle: "مسار فاس وشمال المغرب (شامل كلياً)",
      routeText: "ليلتان في فاس، ليلة في شفشاون، ليلة في طنجة، ليلة في إفران، ليلة أخيرة في فاس",
      flight1: "رحلات طيران مباشرة ذهاباً وإياباً من أوروبا",
      flight2: "حقيبة 20 كجم + حقيبة مقصورة",
      trans1: "الاستقبال والتوصيل في المطار",
      trans2: "سائق خاص محترف ومرشد سياحي",
      trans3: "مركبات جديدة مكيفة",
      hotel1: "فنادق 4-5 نجوم",
      hotel2: "مواقع ممتازة",
      hotel3: "خدمة عالية المستوى",
      food1: "نصف إقامة",
      food2: "مطبخ أصيل",
      food3: "شاي وحلويات تقليدية",
      exp1: "عروض مغربية حية",
      exp2: "أسواق تقليدية (التوابل، الفوانيس، السجاد)",
      exp3: "حمام مغربي تقليدي",
      exp4: "زيارات الطبيعة والغابات",
      exp5: "مطلات جميلة ورحلات يومية",
      exp6: "ورش عمل الطهي والفنون",
      exp7: "زيارات مع عائلات محلية",
      exp8: "مفاجآت خاصة أثناء الرحلة",
      suit1: "الأزواج",
      suit2: "العائلات",
      suit3: "المجموعات",
      suit4: "المسافرون المنفردون",
      suit5: "كبار السن",
      suit6: "الشركات",
      suit7: "وكالات السفر"
    },
    pkg3: {
      title: "تجربة المغرب الكبرى",
      duration: "10 ليالٍ / 11 يوماً (المسافرون العالميون)",
      price: "1990 يورو",
      hl1: "خدمات أرضية ممتازة كاملة",
      hl2: "الدار البيضاء، مراكش وفاس",
      hl3: "أكادير ومفاجآت صحراء السهاري",
      hl4: "زيارة ورزازات وشفشاون",
      hl5: "موسيقى حية وعروض خاصة",
      subtitle: "✨ تجربة المغرب الكبرى (الخدمات الأرضية فقط)",
      arrivalText: "الدار البيضاء أو مراكش",
      routeText: "الدار البيضاء، الرباط، ليلتان في فاس، طنجة، شفشاون، إفران، ليلتان في مراكش، أكادير، ورزازات، ليلة أخيرة في مراكش",
      note2: "المجموعات > 40: خصم خاص بقيمة 50 دولاراً للشخص",
      note3: "رحلات الطيران الدولية والتأمين غير مشمولة",
      note4: "الإكراميات للسائق/المرشد غير مشمولة",
      inc1: "خدمات أرضية ممتازة كاملة",
      inc2: "فنادق 4-5 نجوم (نصف إقامة)",
      inc3: "مرشد سياحي محترف وسائق خاص",
      inc4: "حافلة أو حافلة صغيرة مكيفة",
      inc5: "عروض حية وأجواء موسيقية",
      inc6: "الأسواق التقليدية وزيارات الحمام",
      inc7: "ورش عمل الطهي والفنون",
      inc8: "رحلات إلى الغابات، الينابيع والمطلات",
      inc9: "زيارات مع عائلات محلية",
      inc10: "مفاجآت خاصة أثناء الرحلة"
    },
    pkg4: {
      title: "تجربة المغرب الإمبراطوري والصحراء",
      duration: "13 ليلة / 14 يوماً",
      price: "شامل كلياً",
      hl1: "ليلتان في صحراء مرزوكة",
      hl2: "خيام ممتازة مكيفة ورحلات جيب",
      hl3: "زيارة جبال الأطلس ووادي أوريكا",
      hl4: "شلالات أوزود والمدن الإمبراطورية",
      hl5: "خدمات أرضية كاملة من الألف إلى الياء",
      subtitle: "✨ تجربة المغرب الإمبراطوري والصحراء (خدمات أرضية كاملة)",
      routeText: "ليلتان في مراكش، وادي أوريكا، أكادير، ليلتان في مرزوكة، ورزازات، شلالات أوزود، إفران، طنجة، شفشاون، ليلتان في فاس، الجديدة، الدار البيضاء",
      sahara1: "خيام صحراوية ممتازة مكيفة",
      sahara2: "أجواء موسيقية حول موقد النار",
      sahara3: "رحلات جيب وركوب جمال",
      sahara4: "غروب وشروق شمس لا ينسى",
      inc1: "خدمات أرضية ممتازة كاملة",
      inc2: "فنادق 4-5 نجوم (نصف إقامة)",
      inc3: "مرشد سياحي محترف وسائق خاص",
      inc4: "عروض حية خاصة وراقصون",
      inc5: "أسواق التوابل، السجاد والفوانيس التقليدية",
      inc6: "حمام مغربي تقليدي",
      inc7: "ورش عمل الطهي والفنون"
    }
  },
  destinations: {
    pageTitle: "استكشف وجهات المغرب",
    pageSubtitle: "اكتشف أماكن رائعة للزيارة في المغرب الجميل",
    sectionTitle: "جميع الوجهات",
    sectionIntro: "المغرب بلد المناظر المتنوعة والتراث الثقافي الغني. استكشف وجهاتنا المختارة بعناية:",
    exploreNow: "استكشف الآن",
    ctaTitle: "مستعد لتخطيط رحلتك؟",
    ctaText: "تصفح جولاتنا وباقاتنا لإيجاد التجربة المغربية المثالية",
    ctaBtn: "عرض الجولات والباقات"
  },
  experiences: {
    pageTitle: "التميز الطهوي المغربي",
    pageSubtitle: "اكتشف طعامنا — الأفضل في العالم",
    bookViaWhatsApp: "احجز عبر واتساب"
  },
  vip: {
    pageTitle: "سفر VIP والأعمال",
    pageSubtitle: "خدمات حصرية للمدراء التنفيذيين والمستثمرين والمسافرين المميزين",
    introTitle: "تميز سلس في المغرب",
    introText: "MoroccoLovesYou تقدم مستوى خدمة لا مثيل له للمسافرين من رجال الأعمال والوفود والضيوف VIP.",
    ctaTitle: "وصول مباشر للمدير التنفيذي",
    ctaText: "للاستفسارات العاجلة، تحدث مباشرة مع المؤسس والمدير التنفيذي، إيلان هاتشويل.",
    ctaBtn: "تواصل مع إيلان الآن",
    luxuryTransport: "نقل فاخر",
    luxuryTransportDesc: "نقل VIP من المطار وسائقون خاصون ثنائيو اللغة 24/7 بسيارات فاخرة.",
    premiumAccom: "إقامات ممتازة",
    premiumAccomDesc: "حجوزات حصرية في فنادق 5 نجوم أو رياض فاخرة أو فيلات خاصة.",
    businessConcierge: "خدمة كونسيرج الأعمال",
    businessConciergeDesc: "مساعدة كاملة للاجتماعات وحجوزات العشاء الخاصة.",
    securityPrivacy: "الأمان والخصوصية",
    securityPrivacyDesc: "خدمة سرية وبيئات آمنة وسرية تامة.",
    support247: "دعم 24/7",
    support247Desc: "تواصل مباشر مع المدير التنفيذي وفريق مخصص جاهز لمساعدتك في أي وقت.",
    customItineraries: "برامج رحلات مخصصة",
    customItinerariesDesc: "خطط سفر مصممة توازن بين التزاماتك المهنية والتجارب الثقافية المغربية."
  },
  worldcup: {
    pageTitle: "كأس العالم المغرب 2030",
    pageSubtitle: "باقات VIP حصرية لأكبر حدث رياضي",
    limitedBadge: "توفر محدود",
    introTitle: "الرحلة الكروية النهائية",
    introText: "في 2030، سيستضيف المغرب كأس العالم FIFA. MoroccoLovesYou فخورة بتقديم باقات فاخرة حصرية شاملة.",
    packagesTitle: "باقات كأس العالم المميزة",
    silverTitle: "الباقة الفضية",
    silverSub: "التجربة الأساسية",
    goldTitle: "الباقة الذهبية",
    goldSub: "تجربة الفخامة",
    mostPopular: "الأكثر شعبية",
    diamondTitle: "الماس VIP",
    diamondSub: "التجربة النهائية",
    inquireWhatsApp: "استفسر عبر واتساب",
    ctaTitle: "احجز مكانك قبل ارتفاع الأسعار",
    ctaText: "بسبب الطلب الدولي المرتفع، ننصح بحجز باقتك VIP مبكراً.",
    ctaBtn: "تواصل معنا اليوم",
    silverF1: "رياض ممتاز / فندق 4 نجوم",
    silverF2: "لوجستيات يوم المباراة مخططة مسبقاً",
    silverF3: "جولات إرشادية في المدن المضيفة",
    silverF4: "خط دعم مخصص 24/7",
    goldF1: "فندق 5 نجوم / فيلا فاخرة",
    goldF2: "نقل خاص للمطار والمباريات",
    goldF3: "مخيم صحراوي VIP (يومان)",
    goldF4: "كونسيرج شخصي ثنائي اللغة",
    diamondF1: "أجنحة رئاسية / قصور خاصة",
    diamondF2: "سائق خاص وأمن 24/7",
    diamondF3: "وصول حصري لفعاليات VIP والحفلات",
    diamondF4: "إدارة مباشرة من المدير التنفيذي وكونسيرج VVIP"
  },
  gallery: {
    pageTitle: "معرضنا",
    pageSubtitle: "ذكريات بصرية من رحلات مغربية لا تُنسى",
    picturesTitle: "المغرب بالصور",
    picturesIntro: "استكشف مجموعتنا من الصور الرائعة من المغرب",
    videosTitle: "المغرب في حركة",
    videosIntro: "اختبر المغرب من خلال مجموعة الفيديو لدينا"
  },
  testimonials: {
    pageTitle: "آراء الضيوف",
    pageSubtitle: "اقرأ ما يقوله مسافرونا عن تجربتهم المغربية",
    sectionTitle: "مسافرونا السعداء",
    sectionIntro: "آلاف الضيوف الراضين عاشوا سحر المغرب معنا",
    verifiedGuest: "ضيف موثق",
    ratingsTitle: "تقييماتنا",
    avgRating: "التقييم المتوسط",
    verifiedReviews: "تقييمات موثقة",
    fromReal: "من مسافرين حقيقيين",
    custSatisfaction: "رضا العملاء",
    wouldRecommend: "يوصون بنا",
    shareTitle: "شارك تجربتك",
    shareText: "هل كانت رحلتك رائعة معنا؟ نود أن نسمع منك!",
    shareBtn: "أخبرنا قصتك"
  },
  blog: {
    pageTitle: "مدونة السفر",
    pageSubtitle: "قصص ونصائح وأدلة لمغامرتك المغربية",
    sectionTitle: "أحدث مقالات السفر",
    sectionIntro: "اقرأ أحدث مقالاتنا عن السفر في المغرب",
    readMore: "اقرأ المزيد ←",
    by: "بواسطة",
    newsletterTitle: "اشترك في نشرتنا الإخبارية",
    newsletterText: "احصل على أحدث نصائح السفر والعروض الحصرية",
    newsletterPlaceholder: "أدخل بريدك الإلكتروني",
    subscribe: "اشترك"
  },
  contact: {
    pageTitle: "اتصل بنا",
    pageSubtitle: "تواصل مع فريقنا لتخطيط مغامرتك VIP في المغرب",
    getInTouch: "تواصل معنا",
    getInTouchText: "نحن هنا لمساعدتك والإجابة على أي أسئلة. فريقنا جاهز لمساعدتك في تخطيط رحلتك المثالية.",
    address: "العنوان",
    phone: "الهاتف",
    email: "البريد الإلكتروني",
    businessHours: "ساعات العمل",
    followUs: "تابعنا",
    formTitle: "أرسل لنا رسالة",
    successMessage: "✓ شكراً لك! سنرد عليك قريباً.",
    fullName: "الاسم الكامل",
    emailAddress: "البريد الإلكتروني",
    phoneNumber: "رقم الهاتف",
    subject: "الموضوع",
    selectSubject: "اختر موضوعاً",
    tourInquiry: "استفسار عن جولة",
    bookingQuestion: "سؤال عن الحجز",
    customPackage: "باقة مخصصة",
    feedback: "ملاحظات",
    other: "أخرى",
    message: "الرسالة",
    sendMessage: "إرسال الرسالة",
    mapTitle: "موقعنا على الخريطة",
    faqTitle: "الأسئلة الشائعة",
    faq1Q: "ما هو أفضل وقت لزيارة المغرب؟",
    faq1A: "الربيع (أبريل-مايو) والخريف (سبتمبر-أكتوبر) يوفران أفضل طقس.",
    faq2Q: "هل أحتاج تأشيرة لزيارة المغرب؟",
    faq2A: "متطلبات التأشيرة تعتمد على جنسيتك. العديد من الدول لديها دخول بدون تأشيرة حتى 90 يوماً.",
    faq3Q: "ما هي العملة المستخدمة في المغرب؟",
    faq3A: "الدرهم المغربي (MAD) هو العملة الرسمية. أجهزة الصراف الآلي متوفرة على نطاق واسع.",
    faq4Q: "ما هي اللغة المحكية في المغرب؟",
    faq4A: "العربية والأمازيغية هي اللغات الرسمية. الفرنسية تُستخدم على نطاق واسع.",
    faq5Q: "هل المغرب آمن للسياح؟",
    faq5A: "نعم، المغرب آمن بشكل عام للسياح. مرشدونا يضمنون تجربة آمنة وممتعة.",
    faq6Q: "هل يمكنني تخصيص باقتي السياحية؟",
    faq6A: "بالتأكيد! نقدم باقات مخصصة حسب اهتماماتك وميزانيتك ومواعيد سفرك."
  },
  about: {
    pageTitle: "عن MoroccoLovesYou",
    pageSubtitle: "شريكك الموثوق لاكتشاف سحر المغرب",
    storyTitle: "قصتنا",
    storyP1: "تأسست MoroccoLovesYou بمهمة بسيطة: مساعدة المسافرين على تجربة الجمال الأصيل والثقافة والضيافة في المغرب.",
    storyP2: "مؤسستنا أحبت المغرب وأرادت مشاركة هذا الشغف مع العالم.",
    missionTitle: "🎯 مهمتنا",
    missionText: "تقديم تجارب سفر استثنائية تعرض التراث الثقافي الغني للمغرب.",
    visionTitle: "🌟 رؤيتنا",
    visionText: "أن نكون شركة السياحة الرائدة في المغرب المعروفة بالأصالة والموثوقية.",
    whyTitle: "لماذا تختار MoroccoLovesYou؟",
    expertTitle: "خبرة متخصصة",
    expertText: "فريقنا لديه معرفة واسعة بالمغرب.",
    localTitle: "روابط محلية",
    localText: "نعمل مع مرشدين وعائلات محلية أصيلة.",
    valueTitle: "أفضل قيمة",
    valueText: "أسعار تنافسية دون المساومة على الجودة.",
    safetyTitle: "الأمان والدعم",
    safetyText: "دعم العملاء 24/7 وتأمين سفر شامل.",
    sustainTitle: "سياحة مستدامة",
    sustainText: "ندعم المجتمعات المحلية ونمارس السياحة المسؤولة.",
    bookingTitle: "حجز سهل",
    bookingText: "عملية حجز بسيطة مع خيارات دفع مرنة.",
    teamTitle: "فريقنا",
    teamSubtitle: "تعرف على الأشخاص المتحمسين وراء MoroccoLovesYou",
    happyTravelers: "مسافرون سعداء",
    yearsExp: "سنوات خبرة",
    destinationsCount: "وجهات",
    satisfactionRate: "معدل الرضا"
  },
  footer: {
    description: "اكتشف سحر المغرب معنا. عش مغامرات لا تُنسى واصنع ذكريات دائمة.",
    quickLinks: "روابط سريعة",
    more: "المزيد",
    contactInfo: "معلومات الاتصال",
    copyright: "© 2024 MoroccoLovesYou. جميع الحقوق محفوظة."
  },
  starBanner: {
    ceoMessage: "رسالة المدير التنفيذي",
    watchVideo: "شاهد الفيديو",
    readMessage: "واقرأ رسالتي",
    getToKnow: "تعرف على",
    ilanPersonally: "إيلان شخصياً"
  },
  tourMini: {
    days: "10 أيام",
    nights: "/ 9 ليالٍ",
    title: "جولة المغرب\nالمميزة",
    years: "2026 - 2027",
    departures: "مغادرات شهرية",
    allIncluded: "شامل الكل\nإقامة كاملة",
    recommendations: "توصيات",
    recCount: "أكثر من 500 مسافر سعيد"
  },
  cityDetail: {
    notFound: "المدينة غير موجودة",
    backHome: "العودة للرئيسية",
    discoverSubtitle: "اكتشف الجمال والثقافة",
    planTrip: "خطط رحلتي إلى",
    galleryOf: "معرض",
    bookExperience: "احجز هذه التجربة",
    requestItinerary: "اطلب خط السير الكامل",
    readyToVisit: "مستعد لزيارة",
    readyToVisitText: "دعنا نخطط رحلتك المثالية إلى هذه الوجهة المذهلة",
    planMyTrip: "خطط رحلتي",
    talkExpert: "تحدث مع خبير"
  },
  transportation: {
    pageTitle: "نقل VIP وسائقون محترفون",
    pageSubtitle: "الفخامة والراحة والأمان في جميع أنحاء المغرب",
    introTitle: "خدمة النقل والسائقين VIP لدينا",
    introP1: "في Morocco Loves You، النقل ليس مجرد انتقال من مكان إلى آخر.",
    introP2: "إنه جزء من التجربة.",
    introP3: "نحن نوفر مركبات حديثة، نظيفة، مريحة، ومكيفة بالكامل في جميع أنحاء المغرب — مع سائقين محترفين، وضيافة دافئة، وخدمة VIP من اللحظة الأولى.",
    introP4: "سواء كنت تسافر كزوجين، أو عائلة، أو وفد أعمال، أو مجموعة خاصة، فنحن نضمن أن تكون رحلتك آمنة ومريحة ولا تُنسى.",
    servicesTitle: "خدمات النقل لدينا تشمل",
    servicesList: [
      "حافلات VIP حديثة",
      "حافلات صغيرة فاخرة",
      "سيارات خاصة",
      "سيارات جيب 4x4 لمغامرات الصحراء",
      "ليموزين VIP",
      "الاستقبال والتوديع في المطار",
      "سائقون محترفون يتحدثون عدة لغات",
      "تكييف هواء مريح",
      "مركبات نظيفة ومنظمة",
      "ثلاجات في مركبات مختارة",
      "أنظمة تلفزيون وترفيه",
      "موسيقى أثناء الرحلة",
      "قيادة آمنة وسلسة",
      "مساعدة على مدار الساعة في جميع أنحاء المغرب"
    ],
    driversTitle: "تعرف على سائقينا",
    driversText1: "سائقونا جزء من عائلة Morocco Loves You.",
    driversText2: "محترفون، محترمون، ذوو خبرة، ومستعدون دائماً للمساعدة بابتسامة.",
    driversText3: "العديد من سائقينا يتحدثون لغات متعددة ويعرفون المغرب بعمق — مما يساعد ضيوفنا على الشعور بالراحة والأمان والتواصل طوال الرحلة.",
    safetyTitle: "الأمان والراحة أولاً",
    safetyText1: "راحتك وسلامتك هما أولوياتنا القصوى.",
    safetyText2: "يتم صيانة جميع المركبات وتنظيفها وتجهيزها بعناية قبل كل رحلة.",
    safetyText3: "نحن نعمل فقط مع سائقين محترفين موثوقين وشركاء نقل ذوي جودة عالية.",
    categories: {
      buses: "حافلات VIP",
      minibuses: "حافلات صغيرة فاخرة",
      cars: "سيارات خاصة ونقل VIP",
      jeeps: "سيارات جيب 4x4 ونقل صحراوي",
      meetDrivers: "تعرف على سائقينا",
      videos: "فيديوهات تجربة النقل"
    },
    videoGalleryTitle: "فيديوهات تجربة VIP",
    ctaTitle: "مستعد لاستكشاف المغرب براحة؟",
    moroccoLine: "الخط المباشر للمغرب: +212 6 63 63 05 79"
  },
  jewishHeritage: {
    pageTitle: "جولات كوشر الفاخرة في المغرب",
    pageSubtitle: "تراث يهودي أصيل، مطبخ كوشر 100%، ضيافة فاخرة وتجارب مغربية فريدة.",
    introTitle: "تجربة التراث اليهودي الفاخرة",
    introHeading: "اكتشف المغرب اليهودي الأصيل",
    introText: "اكتشف الجذور العميقة للتاريخ اليهودي في المغرب من خلال تجربة سفر أنيقة وأصيلة وفاخرة. نحن متخصصون في تقديم رحلة سلسة للرعايا والجاهات اليهودية من جميع أنحاء العالم، مع التركيز على التراث والتواصل والراحة المطلقة.",
    introQuote: "\"المغرب بلد التسامح والتعايش، حيث يتم الحفاظ على التراث اليهودي بالحب والاحترام.\"",
    experiencesTitle: "تجارب الكوشر لدينا تشمل",
    experiencesList: [
      "طعام ومطاعم كوشر 100%",
      "طاهٍ كوشر خاص متاح",
      "أطباق يهودية مغربية تقليدية",
      "فنادق فاخرة 4 و5 نجوم",
      "وسائل نقل خاصة VIP",
      "مرشدون محترفون يتحدثون عدة لغات",
      "جولات التراث اليهودي والكنائس",
      "المقابر والمتاحف اليهودية",
      "تجارب صحراء السهاري والحمامات",
      "مساعدة احترافية 24/7"
    ],
    expFood: "طعام كوشر 100%",
    expRestaurant: "مطعم كوشر",
    expChef: "طاهٍ كوشر خاص متاح",
    expCuisine: "المطبخ اليهودي المغربي التقليدي",
    expHotels: "فنادق فاخرة 4 و5 نجوم",
    expDeluxeHotels: "فنادق ديلوكس متوفرة عند الطلب",
    expTransport: "نقل خاص VIP",
    expDrivers: "سائقون محترفون",
    expAC: "مركبات مكيفة",
    expWifi: "واي فاي وتلفزيون وثلاجات في مركبات مختارة",
    expGuides: "مرشدون محترفون يتحدثون عدة لغات",
    expStaff: "طاقم يتحدث العبرية / الإنجليزية / الفرنسية / الإسبانية / الروسية / الألمانية",
    expHeritage: "جولات التراث اليهودي",
    expSynagogues: "كنائس يهودية قديمة",
    expCemeteries: "مقابر يهودية",
    expMuseums: "متاحف يهودية",
    expSpiritual: "تجارب روحية وثقافية",
    expDesert: "تجارب صحراء السهاري",
    expHammam: "تجارب حمامات مغربية",
    expAttractions: "معالم سياحية فريدة في المغرب",
    expAssistance: "مساعدة على مدار الساعة 24/7",
    packagesTitle: "باقات سفر كوشر مرنة",
    packagesIntro: "نحن نخصص كل رحلة وفقًا للاحتياجات والتقاليد وأسلوب السفر والتواريخ وتوقعات ضيوفنا.",
    packageOptions: ["4-5 أيام", "7-8 أيام", "10-11 يومًا", "13-14 يومًا", "21 يومًا", "جولات خاصة مصممة حسب الطلب"],
    package4_5: "4-5 أيام",
    package7_8: "7-8 أيام",
    package10_11: "10-11 يومًا",
    package13_14: "13-14 يومًا",
    package21: "21 يومًا",
    packageTailor: "جولات خاصة مصممة حسب الطلب",
    packagesQuote: "“نحن نخصص كل رحلة وفقًا للاحتياجات والتقاليد وأسلوب السفر والتواريخ وتوقعات ضيوفنا.”",
    safetyTitle: "سفر مريح ومحترف وآمن",
    safetyText: "تدار جولاتنا باهتمام بالغ بالراحة والتنظيم وجودة الخدمة والتنسيق الاحترافي في جميع أنحاء المغرب.",
    safetyQuote: "“تدار جولاتنا باهتمام بالغ بالراحة والتنظيم وجودة الخدمة والتنسيق الاحترافي في جميع أنحاء المغرب.”",
    b2bTitle: "شراكات سفر يهودية B2B",
    b2bText: "نحن نتشارك مع الجاليات اليهودية والكنائس والحاخامات ومشغلي جولات الكوشر في جميع أنحاء العالم لإنشاء رحلات تراثية هادفة.",
    b2bPartnersList: "نحن نعمل مع: الجاليات اليهودية، الكنائس، الحاخامات، المنظمات اليهودية، مشغلي جولات الكوشر، ووكالات السفر في جميع أنحاء العالم.",
    partnerBtn: "شراكة معنا",
    galleryTitle: "معرض تجربة الكوشر",
    videosTitle: "فيديوهات مميزة",
    ctaTitle: "هل أنت مستعد لبدء رحلتك؟",
    msgAllan: "راسل ألان على واتساب",
    callMorocco: "اتصل بالمغرب: +212 6 63 63 05 79",
    ceoContact: "تحدث مع ألان هاتشويل مباشرة على واتساب",
    exploreBtn: "استكشف جولات كوشر"
  },

  // Accessibility & UI Labels (ملصقات الوصول والواجهة)
  aria: {
    selectLanguage: "اختر اللغة",
    closeDetails: "إغلاق التفاصيل",
    openMenu: "فتح القائمة",
    closeMenu: "إغلاق القائمة",
    kosherTravel: "سياحة كوشر في المغرب",
    watchVideo: "شاهد فيديو المغرب السحري",
    followInstagram: "متابعتنا على إنستاجرام",
    followFacebook: "متابعتنا على فيسبوك",
    ceoMessage: "الرئيس التنفيذي لـ Morocco Loves You",
    whatsappSocial: "واتساب",
    instagramSocial: "إنستاجرام",
    facebookSocial: "فيسبوك",
    jewishHeritageExperience: "تجربة التراث اليهودي",
    kosherFoodMorocco: "طعام كوشر في المغرب",
    jewishHeritageMorocco: "التراث اليهودي في المغرب",
    kosherExperience: "تجربة كوشر",
    luxuryHospitality: "ضيافة فاخرة",
    kosherMoroccanTable: "مائدة مغربية كوشر",
    jewishHeritageArchitecture: "عمارة التراث اليهودي",
    kosherOptionsAlt: "خيارات كوشر",
    kingAlt: "ملك المغرب",
    logoAlt: "شعار MoroccoLovesYou"
  },
  
  // Form Placeholders (عناصر نموذج الملء)
  forms: {
    firstName: "مثلاً: أحمد",
    lastName: "مثلاً: محمد",
    email: "example@example.com",
    subject: "كيف يمكننا مساعدتك؟",
    message: "أخبرنا المزيد عن خطط رحلتك...",
    phone: "رقم هاتفك",
    date: "اختر التاريخ",
    guests: "عدد الضيوف"
  },
  
  // Common UI Text (نص واجهة المستخدم الشائع)
  common: {
    selectLanguage: "اختر اللغة",
    instagram: "إنستاجرام",
    facebook: "فيسبوك",
    loading: "جاري التحميل...",
    error: "حدث خطأ",
    success: "نجح!",
    noResults: "لا توجد نتائج",
    viewMore: "عرض المزيد",
    viewLess: "عرض أقل",
    bookNow: "احجز الآن",
    learnMore: "تعرف على المزيد",
    contactUs: "اتصل بنا",
    close: "إغلاق",
    back: "رجوع",
    next: "التالي",
    previous: "السابق",
    search: "البحث...",
    filter: "تصفية",
    sort: "ترتيب",
    price: "السعر",
    duration: "المدة",
    languages: {
      english: "English",
      american: "American",
      australia: "Australia",
      canada: "Canada",
      french: "Français",
      spanish: "Español",
      hebrew: "עברית",
      arabic: "العربية",
      german: "Deutsch",
      italian: "Italiano",
      japanese: "日本語",
      chinese: "中文",
      korean: "한국어",
      vietnamese: "Tiếng Việt",
      russian: "Русский"
    }
  },
  
  // WhatsApp Message Templates (قوالب رسائل واتساب)
  whatsapp: {
    greeting: "مرحباً Morocco Loves You! 🌟",
    bookPackage: "أود حجز الباقة التالية:",
    packageInfo: "📦 الباقة: ",
    duration: "⏱️ المدة: ",
    price: "💰 السعر: ",
    bookingRequest: "يرجى إخبارني بالتوفر والخطوات التالية. شكراً لك!",
    cityTrip: "أود التخطيط لرحلة إلى {city}. هل يمكنك مساعدتي؟",
    silverPackage: "أنا مهتم بباقة Silver لكأس العالم",
    goldPackage: "أنا مهتم بباقة Gold لكأس العالم",
    diamondPackage: "أنا مهتم بباقة Diamond VIP لكأس العالم",
    worldCupSecure: "مرحباً، أريد تأمين مكاني لـ Morocco 2030.",
    kosherInquiry: "أنا مهتم بباقات السفر الكوشر لديكم.",
    customPackage: "أود إنشاء باقة مخصصة لمجموعتنا.",
    businessInquiry: "أنا مهتم بخدمات السفر الفاخر للأعمال."
  },
  
  // Blog Posts (مقالات المدونة)
  blog_posts: {
    post1: {
      title: "10 جواهر مخفية لاكتشافها في المغرب",
      author: "فاطمة حسن",
      date: "15 مارس 2024",
      category: "دليل السفر",
      excerpt: "اكتشف الوجهات الأقل شهرة والكنوز المخفية في المغرب. من قرى الجبال السرية إلى المناطق الساحلية البكر، استكشف المغرب الأصيل.",
      content: "المغرب أكثر بكثير من مراكش والدار البيضاء. يكشف هذا الدليل الشامل عن الجواهر المخفية..."
    },
    post2: {
      title: "أفضل وقت لزيارة المغرب: دليل شامل",
      author: "أحمد البناني",
      date: "10 مارس 2024",
      category: "التخطيط",
      excerpt: "هل تخطط لرحلة إلى المغرب؟ تعرف على أفضل الفصول للزيارة والطقس المتوقع.",
      content: "اختيار الوقت المناسب لزيارة المغرب يمكن أن يؤثر بشكل كبير على تجربة السفر. إليك دليلنا الكامل..."
    },
    post3: {
      title: "المطبخ المغربي: مغامرة طهوية",
      author: "ليلى رحيم",
      date: "5 مارس 2024",
      category: "الطعام والثقافة",
      excerpt: "انطلق في رحلة طهوية عبر المغرب. اكتشف النكهات الغنية والوصفات التقليدية وتجارب الطعام.",
      content: "المطبخ المغربي مزيج من التأثيرات العربية والأمازيغية والأندلسية والأفريقية. كل طبق يحكي قصة..."
    },
    post4: {
      title: "كيفية المساومة في الأسواق المغربية كالمحترفين",
      author: "يوسف العلاوي",
      date: "28 فبراير 2024",
      category: "نصائح السفر",
      excerpt: "أتقن فن المساومة في الأسواق والمتاجر المغربية. تعرف على الآداب الثقافية والتكتيكات والنصائح.",
      content: "المساومة في الأسواق المغربية ليست مجرد معاملة؛ إنها تبادل ثقافي. إليك كيفية القيام بها بشكل احترافي..."
    },
    post5: {
      title: "تسلق جبال الأطلس: ما تحتاج إلى معرفته",
      author: "أحمد البناني",
      date: "20 فبراير 2024",
      category: "المغامرة",
      excerpt: "استكشف جبال الأطلس الجميلة سيراً على الأقدام. احصل على نصائح الخبراء حول المسارات والتجهيزات.",
      content: "تقدم جبال الأطلس بعضاً من أكثر المناظر الطبيعية المذهلة في شمال أفريقيا. سواء كنت متنزهاً متمرساً أم مبتدئاً..."
    },
    post6: {
      title: "سفاري الصحراء: تجربة لا تُنسى",
      author: "فاطمة حسن",
      date: "15 فبراير 2024",
      category: "المغامرة",
      excerpt: "اختبر سحر صحراء المغرب. ركوب الجمال والليالي المرصعة بالنجوم وشروق الشمس الذي لن تنساه.",
      content: "تمثل صحراء الساهارا روح المغرب. سفاري الصحراء أكثر من مجرد مغامرة؛ إنها رحلة精神ية..."
    },
    post7: {
      title: "الآداب الثقافية: احترام التقاليد المغربية",
      author: "ليلى رحيم",
      date: "10 فبراير 2024",
      category: "الثقافة",
      excerpt: "تعرف على القواعد والعادات الثقافية الأساسية للتفاعل بشكل احترافي مع الشعب المغربي.",
      content: "فهم واحترام العادات المحلية أمر بالغ الأهمية عند السفر إلى المغرب. يغطي هذا الدليل الممارسات الثقافية الأساسية..."
    },
    post8: {
      title: "التصوير في المغرب: التقاط السحر",
      author: "يوسف العلاوي",
      date: "5 فبراير 2024",
      category: "التصوير",
      excerpt: "اكتشف أكثر المواقع تصويرية في المغرب والنصائح الاحترافية لالتقاط صور مذهلة.",
      content: "المغرب جنة المصورين. من المدن الزرقاء إلى الصحاري الذهبية، كل زاوية توفر فرصاً تصويرية رائعة..."
    }
  },
  
  // Job Listings (قوائم الوظائف)
  jobs: {
    title: "فرص وظيفية",
    intro: "انضم إلى فريق MoroccoLovesYou وابني مستقبلك في السفر الفاخر",
    workWith: "اعمل بالحب والرعاية والتميز",
    introText: "نبحث عن أفراد متحمسين ومكرسين يشاركون رؤيتنا في تقديم تجارب سفر عالمية المستوى. انضم إلى فريقنا المتنامي وكن جزءاً من شيء خاص.",
    openPositions: "الوظائف المتاحة",
    readyJoin: "هل أنت مستعد للانضمام إلينا؟",
    sendCV: "أرسل سيرتك الذاتية إلى careers@moroccolovesyou.com",
    instructions: "أضف رسالة تعريفية موجزة تشرح سبب رغبتك في الانضمام إلى فريق Morocco Loves You.",
    
    job1: {
      title: "مرشد سياحي مهني متعدد اللغات",
      type: "بدوام كامل / موسمي",
      location: "مراكش / فاس / المغرب",
      description: "نبحث عن مرشدين متحمسين وعارفين يمكنهم إحياء المغرب لضيوفنا الفاخرين. يتضمن دورك قيادة جولات فاخرة ومشاركة الأفكار الثقافية.",
      req1: "متحدث طليق للغتين على الأقل (الفرنسية والإسبانية والإنجليزية والعبرية والألمانية والروسية أو الإيطالية مفضل)",
      req2: "معرفة عميقة بالتاريخ والثقافة والجغرافيا المغربية",
      req3: "مهارات احترافية وودية وخدمة عملاء ممتازة",
      req4: "اللياقة البدنية لرحلات الصحراء والأنشطة الخارجية"
    },
    job2: {
      title: "سائق تنفيذي فاخر",
      type: "بدوام كامل",
      location: "المغرب",
      description: "انضم إلى فريق النقل الفاخر لدينا. توفير تحويلات VIP وضمان راحة وسلامة الضيوف.",
      req1: "رخصة قيادة سارية مع سجل قيادة ممتاز (10 سنوات خبرة على الأقل مفضل)",
      req2: "طلاقة في اللغة الإنجليزية (لغات إضافية إضافة)",
      req3: "مظهر احترافي وسلوك مؤدب",
      req4: "معرفة بطرق المغرب والملاحة"
    },
    job3: {
      title: "منسق تجربة العملاء",
      type: "بدوام كامل",
      location: "عن بُعد / هجين (مكتب فاس)",
      description: "دعم مكتب الرئيس التنفيذي في تنظيم الخط السير المخصص الفاخر وإدارة تواصل الضيوف.",
      req1: "مهارات تنظيمية وتواصلية ممتازة",
      req2: "خبرة في السفر أو الضيافة أو خدمة العملاء",
      req3: "طلاقة في اللغة الإنجليزية؛ لغات إضافية إضافة",
      req4: "إتقان أنظمة الحجز ومجموعة Microsoft Office"
    }
  },
  
  // Testimonials (الشهادات)
  testimonials_data: {
    intro: "التقِ بضيوفنا الراضين الذين عاشوا المغرب من خلال خدماتنا",
    
    testi1: {
      name: "سارة جونسون",
      title: "لندن، المملكة المتحدة",
      rating: 5,
      text: "جعلت Morocco Loves You حلمي رحلة واقع! كل تفصيل تم تنظيمه بعناية. الخدمة لا تضاهى. أنا بالفعل أخطط لزيارتي الثانية!",
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330"
    },
    testi2: {
      name: "مايكل تشين",
      title: "سنغافورة",
      rating: 5,
      text: "كمسافر أعمال، أعجبت بالاحترافية والتخصيص. معاملة VIP من اليوم الأول. موصى به بشدة للسفر التنفيذي.",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d"
    },
    testi3: {
      name: "إيما ويلسون",
      title: "سيدني، أستراليا",
      rating: 5,
      text: "كانت تجربة الصحراء سحرية! النوم تحت النجوم وركوب الجمال تجاوز جميع التوقعات. شكراً لصنع ذكريات دائمة!",
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80"
    },
    testi4: {
      name: "جيمس رودريغيز",
      title: "مدريد، إسبانيا",
      rating: 5,
      text: "تخطيط رحلة عائلية يمكن أن يكون مرهقاً، لكن Morocco Loves You تعامل معها بشكل رائع. آمن وتعليمي وممتع لجميع الأعمار.",
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e"
    },
    testi5: {
      name: "آنا مولر",
      title: "برلين، ألمانيا",
      rating: 5,
      text: "قدرت الأصالة الثقافية والاحترام الذي يُبدى للتقاليد المحلية. لم تكن هذه مجرد سياحة؛ كانت غمراً ثقافياً حقيقياً.",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d"
    },
    testi6: {
      name: "ديفيد طومسون",
      title: "تورنتو، كندا",
      rating: 5,
      text: "كانت إمكانية الوصول للمسنين استثنائية. وتيرة مريحة ومرشدون متعاطفون وإقامات فاخرة. خدمة تهتم حقاً.",
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e"
    },
    testi7: {
      name: "ليزا أندرسون",
      title: "نيويورك، الولايات المتحدة",
      rating: 5,
      text: "كمحب للطعام! كانت التجارب الطهوية رقيقة. كل وجبة حكت قصة، كل مرشد أظهر شغفاً حقيقياً.",
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80"
    },
    testi8: {
      name: "ماركوس سميث",
      title: "لوس أنجليس، الولايات المتحدة",
      rating: 5,
      text: "مليئة بالمغامرة ولكن فاخرة - بالضبط ما كنت أبحث عنه. تسلق الأطلس وسفاري الصحراء، كل شيء براحة VIP.",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d"
    },
    testi9: {
      name: "صوفي لوران",
      title: "باريس، فرنسا",
      rating: 5,
      text: "رحلة رومانسية استثنائية! غروب في الصحراء وعشاء خاص يطل على مراكش. خدمة يقظة في جميع أنحاء الرحلة.",
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330"
    }
  },
  
  // Gallery Categories (فئات المعرض)
  gallery_categories: {
    food: "تجربة طهوية",
    destinations: "الوجهات",
    kosher: "كوشر",
    transport: "نقل VIP"
  },
  
  // Stats (الإحصائيات)
  stats: {
    happyTravelers: "5000+",
    yearsExperience: "15+",
    destinationsCount: "25+",
    satisfactionRate: "98%"
  }
};

export default ar;
